import {makeStyles} from "@material-ui/styles";

export default makeStyles(() => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
      padding: '4px',
      fontSize: '12px',
    }
  }
}))

export const useTableRowStyles = makeStyles(() => ({
  root: {
    '&:hover': {
      background: 'rgba(0,0,0,.05)'
    },
    '& > *': {
      borderBottom: 'unset',
      padding: '4px',
      fontSize: '12px',
    }
  },
  priceFlex: {
    display: 'flex',
    justifyContent: "center",
    alignItems: "center"
  },
  passengersActive: {
    backgroundColor: 'rgba(148,217,125,0.35)',
    '&:hover': {
      backgroundColor: 'rgba(107,212,143,1)'
    }
  },
  passengersDisabled: {
    backgroundColor: '#edd8de',
    '&:hover': {
      backgroundColor: 'rgba(255,0,0,0.4)'
    }
  },
  isDisabledFlight: {
    backgroundColor: 'rgba(37,150,190,0.3)',
    '&:hover': {
      backgroundColor: 'rgba(37,150,190,0.6)'
    }
  },
  rowButtons: {
    '& button': {
      marginRight: '.5rem'
    }
  },
  textIconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    textWrap: 'nowrap',
  },
  icon: {
    fontSize: '18px',
    margin: '0 2px',
    color: '#000',
  },
  addReturnFlightBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: '2px',
    textDecoration: 'underline',
    color: '#178cff',
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: '13px',
  },
  box: {
    fontWeight: 500,
    marginRight: '10px'
  },
  inline: {
    display: 'inline'
  },
  lineThrough: {
    textDecoration: 'line-through',
  },
  marginLeft10: {
    marginLeft: '10px'
  },
  textRed: {
    color: 'rgba(108,13,32,1)',
    fontWeight: 500
  },
  agent: {
    backgroundColor: 'rgba(255,255,0,1)'
  },
  textBold: {
    fontWeight: 700
  },
  ticketColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    height: "100%",
    padding: 10,
  },

  flightPrices: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    marginTop: 50,
  },
  priceLine: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 32, 
  },
  ticketTotals: {
    marginTop: "auto",
    textAlign: "right",
  },
  priceRow: {
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 6,
    marginTop: 10,
    width: '125px',
  },
  basePrice: {
    marginTop: 2,
    fontSize: "11px",
  },
  noFlightModalOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  noFlightModalCard: {
    width: "320px",
    maxWidth: "90vw",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
    border: "1px solid #ececec",
  },
  noFlightModalHeader: {
    padding: "14px 16px",
    fontSize: "18px",
    fontWeight: 700,
    borderBottom: "1px solid #efefef",
  },
  noFlightModalBody: {
    margin: "16px",
    padding: "18px 14px",
    borderRadius: "6px",
    backgroundColor: "#efe4cd",
    color: "#9b4f00",
    fontSize: "18px",
    fontWeight: 700,
    textAlign: "left",
  },
  noFlightModalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
    padding: "0 16px 16px",
  },
  noFlightModalButton: {
    border: "none",
    borderRadius: "6px",
    padding: "8px 14px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    color: "#fff",
    backgroundColor: "#ff5f23",
  },
  }))
